import React from 'react';
import { SectionHeading } from '../SectionHeading';
import { OfferPanel } from '../OfferPanel';
export function SpecialOffer() {
  return <section className="bg-navy2 px-4 py-16 sm:py-20" aria-labelledby="special-offer" data-id="element-244" data-mp="33j1pzev7gndh">
      <div id="special-offer" data-id="element-245" data-mp="3ig2ihkl80md0">
        <SectionHeading tone="dark" eyebrow="Your special offer" title="Get immediate access to the complete clinical blueprint for just $27." data-id="element-246" data-mp="3ic4xsuizvmr0" />
      </div>
      <div className="mx-auto mt-10 max-w-xl" data-id="element-247" data-mp="3rd35bmsn6cec">
        <OfferPanel ctaLabel="Yes! I want better torque planning" data-id="element-248" data-mp="3mgups8aj8h6n" />
      </div>
    </section>;
}